import type { CardProps} from '@chakra-ui/react'
import { Card, forwardRef } from '@chakra-ui/react'

export interface RecapProps extends CardProps { }

export const Recap = forwardRef(
  ({ children, sx, ...rest }: RecapProps, ref) => {
    return (
      <Card sx={{ gap: 8, ...sx }} ref={ref} {...rest}>
        {children}
      </Card>
    )
  }
)
